<nav class="text-center" [ngClass]="'type-'+ListingCategory[currentListingType]" [@rightNavTrigger] *ngIf="showRightNav"
  role="menu">
  <header class="has-pos-rel">
    <i class="material-icons md-24 v-align has-pos-abs" style="left: 2%;" (click)="onCloseRightNavClick.emit()">chevron_left</i>
    <h3 class="text-center">
      <app-circle-initials *ngIf="currentUser.name; else elseBlock" [initials]="currentUser.getInitials()"></app-circle-initials>
      <ng-template #elseBlock>
        <img src="{{(currentListingType===ListingCategory.LUXURY?'/assets/icons/my-account/my-account-golden@1x.svg':'/assets/icons/my-account/my-account@1x.svg') | staticp}}" [alt]="'my-account.my-account'|translate">
      </ng-template>
      <p style="margin-top: 3%;" translate="my-account.my-account"></p>
    </h3>
  </header>
  <ul class="nav nav-tabs nav-justified site-links">
    <li role="presentation" (click)="toFavourites.emit()"
    angulartics2On="click" [angularticsProperties]="'_gotomysavedlistings' | listingTypeAnalyticsTag | async"
    >
      <a translate="side-nav.saved-listings"></a>
      <i class="material-icons chevron-right has-pos-abs">chevron_right</i>
    </li>
    <li role="presentation" (click)="toSavedSearches.emit()">
      <a translate="side-nav.saved-searches"></a>
      <i class="material-icons chevron-right has-pos-abs">chevron_right</i>
    </li>
    <li role="presentation" (click)="toMyAccount.emit()" *appShowAuthed="true">
      <a translate="side-nav.account-details"></a>
      <i class="material-icons chevron-right has-pos-abs">chevron_right</i>
    </li>
    <ng-container *appShowAuthed="true">
      <li role="presentation" (click)="toFavouriteAgent.emit(agentUrl)" *ngIf="agentUrl">
        <a translate="side-nav.favourite-agent"></a>
        <i class="material-icons chevron-right has-pos-abs">chevron_right</i>
      </li>
    </ng-container>
  </ul>
  <br/>
  <ng-container *appShowAuthed="false">
    <p class="text-center">View your favourites and saved searches on any device.</p>
    <button class="btn btn-polar-gradient" (click)="openSignIn.emit($event)" style="width: 80%; margin: 0 auto;">
      <span translate="registration.register-login"></span>
    </button>
  </ng-container>
  <ng-container *appShowAuthed="true">
    <ul class="nav nav-tabs nav-justified site-links">
      <li role="presentation" (click)="logout.emit()">
        <a class="logout" translate="registration.log-out"></a>
      </li>
    </ul>
  </ng-container>
</nav>
